<template class="d-flex flex-column">
    <dx-data-grid
        id="mped-calculation-dx-data-grid"
        class="flex-grow-1"
        height="50px"
        width="100%"
        ref="dataGridRef"
        key-expr="id"
        column-resizing-mode="widget"
        filter-mode="fullBranch"
        :columns="selectedColumns"
        :header-filter="{ visible: true }"
        :data-source="dataSource"
        :allow-column-resizing="true"
        :hover-state-enabled="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :show-borders="true"
        :column-min-width="100"
        :column-chooser="{ enabled: true, mode: 'select' }"
        :remote-operations="true"
        @toolbar-preparing="onToolbarPreparing($event)"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <template #filterTemplate>
            <div class="d-flex">
                <mped-calculation-period-component
                    v-model:value="periodValue"
                    :visible="selectedPage !== 3"
                    @value-changed="onPeriodChanged($event)"
                    :default-period="'current'"
                    :show-clear-button="false"
                    selection-mode="single"
                />
                <dx-select-box v-if="selectedPage !== 3"
                    v-model="viewMode"
                    :visible="selectedPage !== 3"
                    :data-source="viewModeData"
                    placeholder="Режим просмотра"
                    width="100%"
                    value-expr="filter"
                    display-expr="name"
                    :showClearButton="false"
                    @valueChanged='onViewChanged()'
                ></dx-select-box>
            </div>
        </template>
    </dx-data-grid>
    <div class="flex justify-content-between items-center">
        <div class="ai-tab-bar-container d-flex">
            <div v-for="item in reportPages" :key="item.id">
                <ai-tab-bar-item
                    :id="item.id"
                    :key="item.name"
                    :view="{ id: item.id, name: item.name, title: item.title, buttonCloseHide: true }"
                    :name="item.name"
                    :use-route="false"
                    :focused="item.id === selectedPage"
                    @item-click="onTabTitleClick"/>
            </div>
        </div>
      <footer-grid
        class="pr-1"
        :totalCount="totalCount"
        :showSelectedCounter="false"
      ></footer-grid>
    </div>
</template>

<script>
export default {
    name: 'mped-calculation-upload-report-view',
};
</script>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue';
import {
    DxDataGrid,
    DxLoadPanel,
    DxScrolling,
    DxSorting
} from 'devextreme-vue/data-grid';
import { DxSelectBox } from 'devextreme-vue';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import AiTabBarItem from '@/layouts/main-layout/components/tab-bar/tab-bar-item.vue';
import MpedCalculationPeriodComponent from '@/views/mped/views/calculation/component/mped-calculation-period-component.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';
import {
    reportPages,
    reportViewMods,
    getCalculationReportColumns,
} from '@/views/mped/services/mped-calculation-service';
import {
    getUploadReport,
    getUploadReportGrouped,
    getUploadReportDoubleSap,
} from '@/views/mped/services/mped-calculation-api-service';

const
    dataGridRef = ref (),
    periodValue = ref(null),
    viewMode = ref('kod_spr_vid_dey'),
    viewModeData = ref(),
    totalCount = ref(0),
    selectedPage = ref(1),
    selectedColumns = ref();

const dataSource = getAiDataSource(
    {
        dataFn: (params) => {
            switch (selectedPage.value) {
                case 1: return getUploadReport(params);
                case 2: return getUploadReportGrouped(params);
                case 3: return getUploadReportDoubleSap(params);
            }
        },
        key: 'kod_sp_calc',
        remoteOperation: true,
        validationFn: () => {
            return periodValue.value && periodValue.value.length;
        },
        paramsFn: () => Object.assign({}, { viewMode: viewMode.value, period: periodValue.value[0] }),
        customFilterFn: () => {
            let filterArr = [];
            filterArr.push(periodValue.value.reduce((total, item) => {
                total.push(['period', '=', Number(item)]);
                return total;
            }, []));
            filterArr.push('and');
            filterArr.push([viewMode.value, '=', null]);
            return filterArr
        },
        onLoadedFn: (data) => {
            totalCount.value = data.totalCount;
        },
    },
);

onBeforeMount(() => {
    selectedColumns.value = getCalculationReportColumns(viewMode);
    viewModeData.value = reportViewMods;
});

onMounted(() => {
    changeVisibleColumns(1);
})

const onToolbarPreparing = (e) => {
    getAiToolbar(e, {
        customs: [{
            location: 'before',
            template: 'filterTemplate',
        }],
        refresh: {
            event: reloadData,
        },
    });
};

const reloadData = () => {
    dataSource.reload();
};

const onPeriodChanged = (e) => {
    reloadData();
}

const onViewChanged = (e) => {
    changeVisibleColumns(selectedPage.value);
    reloadData();
}

const onTabTitleClick = (view) => {
    if (selectedPage.value !== view.id) {
        selectedPage.value = view.id;
        changeVisibleColumns(selectedPage.value);
        reloadData();
    }
};

const changeVisibleColumns = (newPage) => {
    selectedColumns.value.forEach(x => {
        x.visible = (x.viewArea === newPage || (x.viewMode === viewMode.value && newPage !== 3)) && x.alwaysVisible !== false;
        x.showInColumnChooser = x.alwaysVisible !== false ? x.visible : true;
    });
    dataGridRef.value.instance.option('columns', selectedColumns.value.map(x => {
        return { ...x }
    }));
}

</script>

<style scoped>

</style>
